import { REGISTER } from "../actionTypes";

const initialState = {
  id: "",
  refCode: "",
};

export const registerReducer = (state = initialState, action) => {
  //console.log("registerReducer action: ", action);
  switch (action.type) {
    case REGISTER:
      return {
        ...state,
        id: action.id,
        ref: action.ref,
      };

    default:
      return state;
  }
};
